import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";

/**
 * Returns a handler that goes back one step in history when the user
 * navigated here from within the app, and otherwise falls back to the
 * given path. Distinguishes the two via `location.key`, which is the
 * literal string `"default"` only for the initial page load.
 */
export function useSmartBack(fallback: string): () => void {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (location.key !== "default") {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  }, [navigate, location.key, fallback]);
}
